import { Description, Edit, Print } from "@mui/icons-material";
import { Box } from "@mui/material";
import useApi from "_api/index";
import { BackButton } from "components/Button";
import Actions from "components/Car/Actions";
import FormDocumentList from "components/Car/FormDocumentList";
import ModalContractBuyAndSell from "components/Modal/Car/FormDocuments/ContractBuyAndSell";
import ModalPowerOfAttorney from "components/Modal/Car/FormDocuments/PowerOfAttorney";
import ModalCreateTransferAndReceiptBuy from "components/Modal/Car/FormDocuments/TransferAndReceiptBuy";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const FormReadySellCar = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const [isPowerOfAttorneyModalOpen, setIsPowerOfAttorneyModalOpen] =
    useState(false);
  const [isContractModalOpen, setIsContractModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [is_sold, setIsSold] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await useApi.ready_car.getReadySellCarById(id);
      if (response.success) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 404) {
        // If 404 error, navigate back to /car/ready_cars
        fetchDataSoldById();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) {
      console.error("ID is not provided");
      return;
    }
    fetchData();
  }, [id]);

  const fetchDataSoldById = async () => {
    setLoading(true);
    try {
      const response = await useApi.sold_car.getSoldCarById(id);
      if (response.success) {
        setData(response.data);
        setIsSold(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintPDF = async (document) => {
    let response = null;
    try {
      if (document.document_type === "car_transform") {
        response = await useApi.ready_car.printPdfCarTransferSell(
          document.document_id
        );
      } else if (document.document_type === "car_power_of_attorney") {
        response = await useApi.ready_car.printPdfPowerOfAttorneySell(
          document.document_id
        );
      } else if (document.document_type === "car_sell_contact") {
        response = await useApi.ready_car.printPdfSellCarContract(
          document.document_id
        );
      }
      if (response && response.status === 200) {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(url, "_blank");
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <>
      <FormDocumentList
        data={[
          {
            id: 1,
            document: "แบบคำขอโอนและรับโอน",
            document_type: "car_transform",
          },
          {
            id: 2,
            document: "หนังสือมอบอำนาจ",
            document_type: "car_power_of_attorney",
          },
          {
            id: 3,
            document: "หนังสือสัญญาซื้อ - ขายรถ",
            document_type: "car_sell_contact",
          },
        ]}
        loading={loading}
        setLoading={setLoading}
        car={data ? data.car : null}
        customer={data ? data.customer : null}
        type="sell_car"
        columns={[
          { key: "document", label: "ฟอร์มเอกสาร" },
          {
            key: "action",
            label: "",
            style: {
              textAlign: "right",
            },
            render: (row) => {
              const findCreated =
                data && data.documents
                  ? data.documents.find(
                      (d) => d.document_type === row.document_type
                    )
                  : null;
              console.log("findCreated", findCreated);

              return (
                <Actions
                  menuList={[
                    !is_sold && {
                      label: findCreated ? "แก้ไขเอกสาร" : "สร้างเอกสาร",
                      icon: findCreated ? <Edit /> : <Description />,
                      onClick: () => {
                        // handleUpdateStsatus(row.document);
                        console.log("row", row);
                        if (row.id === 1) {
                          setIsTransferModalOpen(true);
                        } else if (row.id === 2) {
                          setIsPowerOfAttorneyModalOpen(true);
                        } else if (row.id === 3) {
                          setIsContractModalOpen(true);
                        }

                        if (findCreated) {
                          setSelectedRow(findCreated);
                        }
                      },
                    },
                    findCreated && {
                      label: "พิมพ์เอกสาร",
                      icon: <Print />,
                      onClick: () => {
                        //print
                        handlePrintPDF(findCreated);
                      },
                    },
                  ]}
                />
              );
            },
          },
        ]}
      />
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-start" }}>
        <BackButton
          onClick={() => {
            if (is_sold) {
              navigate("/car/sold_cars");
            } else {
              navigate("/car/ready_cars");
            }
          }}
        />
      </Box>

      <ModalCreateTransferAndReceiptBuy
        isOpen={isTransferModalOpen}
        onClose={() => {
          setIsTransferModalOpen(false);
          setSelectedRow(null);
        }}
        car={data ? data?.car : null}
        order={data ? data?.order_sell : null}
        customer={data ? data?.order_sell?.customer_sell : null}
        document={selectedRow ? selectedRow : null}
        type="sell_car"
        onSuccess={() => {
          setIsTransferModalOpen(false);
          setSelectedRow(null);
          if (data?.documents?.length === 2) {
            fetchDataSoldById();
          } else {
            fetchData();
          }
        }}
      />

      <ModalPowerOfAttorney
        isOpen={isPowerOfAttorneyModalOpen}
        onClose={() => {
          setIsPowerOfAttorneyModalOpen(false);
          setSelectedRow(null);
        }}
        car={data ? data.car : null}
        order={data ? data?.order_sell : null}
        document={selectedRow ? selectedRow : null}
        type="sell_car"
        onSuccess={() => {
          setIsPowerOfAttorneyModalOpen(false);
          setSelectedRow(null);
          if (data?.documents?.length === 2) {
            fetchDataSoldById();
          } else {
            fetchData();
          }
        }}
      />

      <ModalContractBuyAndSell
        isOpen={isContractModalOpen}
        onClose={() => {
          setIsContractModalOpen(false);
          setSelectedRow(null);
        }}
        car={data ? data.car : null}
        order={data ? data?.order_sell : null}
        customer={data ? data?.order_sell?.customer_sell : null}
        document={selectedRow ? selectedRow : null}
        type="sell_car"
        onSuccess={() => {
          setIsContractModalOpen(false);
          setSelectedRow(null);
          if (data?.documents?.length === 2) {
            fetchDataSoldById();
          } else {
            fetchData();
          }
        }}
      />
    </>
  );
};

export default FormReadySellCar;
